import React from 'react'
import IconLink from '../IconLink/IconLink'

const TitleIconBlock = ({ titleIconBlock }) => {
    const { iconLinks, title } = titleIconBlock || {}
    return (
        <div className="title-icon-block container">
            <div className="py-10 border-t border-b border-solid border-[#2B0737]/20">
                {title && (
                    <h3 className="text-2xl max-w-[400px] lg:text-3xl">
                        {title}
                    </h3>
                )}

                <div>
                    <div className="grid sm:grid-cols-2 xl:grid-cols-4 xl:flex gap-2 sm:gap-x-10">
                        {iconLinks?.map((item, index) => {
                            return (
                                <IconLink
                                    key={index}
                                    icon={item?.icon}
                                    link={item?.link}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TitleIconBlock
